import { z } from 'zod';

export const jobArchitectureSkillLimitsSchema = z.object({
    roleMaximumSkillLimit: z.number(),
    levelMaximumSkillLimit: z.number(),
});

export type JobArchitectureSkillLimits = z.infer<typeof jobArchitectureSkillLimitsSchema>;
